import { Component, OnInit, Directive, Input, HostListener, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, NgControl } from '@angular/forms';
import { Router } from '@angular/router';

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { EguardConfigService } from '../../../../core/services/config.service';
import { EguardValidationService } from '../../../../core/components/validation/validation.service';
import { OrganizationServices } from '../../../shared/services/organization.services';
import { User } from '../../../shared/models/user.model';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { LocalUserService } from '../../../shared/services/localUser';



@Component({
    selector: 'eguard-clerk-userform-component',
    templateUrl: './clerk-userform.component.html',
    styleUrls: ['./clerk-userform.component.scss'],
    providers: [
      CognitoUtil
    ]
})
export class EguardClerkUserFormComponent implements OnInit {

    roles: any;
    userForm: any;

    loading: boolean;

    constructor(
        public dialogRef: MatDialogRef<EguardClerkUserFormComponent>,
        private eguardConfig: EguardConfigService,
        private router: Router,
        private cognitoService: CognitoUtil,
        private formBuilder: FormBuilder,
        private organizationServices: OrganizationServices,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar
    ) {
        this.eguardConfig.setSettings({

            customScrollbars: true,
            routerAnimation : 'fadeIn',
            themeOption : true
        });
        this.createForm();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ngOnInit() {
        this.userForm.patchValue(new User());
    }

    createForm() {
        this.userForm = this.formBuilder.group({
            email: ['', [Validators.required], EguardValidationService.emailValidator],
            first_name: ['', [Validators.required], EguardValidationService.stringOnlyLetters],
            last_name: ['', [Validators.required], EguardValidationService.stringOnlyLetters],
            middle_name: [''],
            role: ['', [Validators.required]]
        });
    }

    Save() {
        this.loading = true ;
        this.organizationServices.createUserInOrganization(this.userForm.value, this.data)
            .subscribe(
            data => {
                this.dialogRef.close(true);
                // this.dialogRef.close('data saved successfully.');
                  this.loading = false ;
                setTimeout(() => {
                    this.snackBar.open('User Created Successfully.', null, {
                        extraClasses: ['success-snackbar'],
                        duration: 5000,
                    });
                }, 500);

            },
            error => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/userfrom/clerk-userform.component.ts